import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { useGlobalModalContext } from "../GlobalModal";
import Profile from '../../pages/Profile';
import { useEffect, useState, useLayoutEffect } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { TransitionProps } from '@mui/material/transitions';
import { addModalNavigation } from '../../helpers/Functions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});


export type ProfileModalProps = {
    memberCode: number;
}


const ProfileModal = NiceModal.create(({ memberCode }: ProfileModalProps) => {
    const modal = useModal();
    const openModalHashStateId = `profile?id=${memberCode}`;

    useLayoutEffect(() => {
        if (modal.visible) {
            window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `./${openModalHashStateId}`)
            localStorage.setItem("modalOpen", JSON.stringify({ name: "profile" }));
        }
    }, [modal.visible])

    // useEffect(() => {
    //     window.addEventListener("popstate", handleBackProfile);
    //     return () => window.removeEventListener("popstate", handleBackProfile);
    // }, [])

    // const handleBackProfile = (e: any) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     modal.hide();
    // }

    const handleCloseModalButton = () => {
        window.history.back();
        modal.hide();
    }




    return (
        <>
            <div>
                <Dialog
                    fullScreen
                    TransitionComponent={Transition}
                    open={modal.visible}
                    disableEscapeKeyDown={true}

                    onClose={handleCloseModalButton}
                >
                    <Profile memberCode={memberCode} />
                </Dialog>
            </div>
        </>


    )
})


export default ProfileModal;